import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OverlayService {
  private isSticky = false;
  public model: BehaviorSubject<boolean>;

  constructor() {
    this.model = new BehaviorSubject<boolean>(false);
  }

  public show(isSticky = false): void {
    this.isSticky = isSticky;
    this.model.next(true);
  }
  public hide(removeSticky = false): void {
    if ((this.isSticky && removeSticky) || !this.isSticky) {
      this.model.next(false);
    }
  }
}
